(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('SidebarSurveyRespondentController', Controller);

    Controller.$inject = ['$scope', 'topBarService', ];

    function Controller($scope, topBarService) {

        topBarService.setTitleAndIcon('Survey', 'fa fa-bullhorn');
    }
})();